import { HTMLAttributes, PropsWithChildren } from 'react';
import styled from 'styled-components';
import { Overlay as Dark } from 'utils/constants';

export interface ModalProps extends HTMLAttributes<HTMLDivElement>, PropsWithChildren {
  show?: boolean;
  showClose?: boolean;
  onClose?: () => void;
}

export const Modal: React.FC<ModalProps> = ({
  show = false,
  showClose = true,
  onClose,
  children,
  className,
  ...props
}) => {
  return (
    <Overlay className={show ? '' : 'hidden'} >
      <Container {...props} className={className}>
        <Content>
          {children}
        </Content>
        {showClose && <Close onClick={onClose} />}
      </Container>
    </Overlay>
  );
};

const Overlay = styled(Dark)`
  z-index: 100;

  &.hidden {
    display: none;
  }

  @media (orientation: landscape) {
    background-color: transparent;
  }
`;

export const Container = styled.div`
  background-image: linear-gradient(0deg, #6E6157 0%, #61533B 21.146%, #CDC28E 53.92%, #5B4E36 77.898%, #6C5E51 100%);
  position: absolute;
  top: 50%;
  left: 50%;
  translate: -50% -50%;
  box-sizing: border-box;
  padding: 2px;
  border-radius: 16px;

  &::before {
    content: '';
    position: absolute;
    width: calc(100% - 4px);
    height: calc(100% - 4px);
    background-image: linear-gradient(130deg, #663243 0%, #21023A 100%);
    border-radius: 16px;
  }

  @media (orientation: portrait) {
    border-radius: 35px;
    padding: 4px;

    &::before {
      width: calc(100% - 8px);
      height: calc(100% - 8px);
      border-radius: 33px;
    }
  }
`;

const Close = styled.button`
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
  background: transparent url(images/icon-close.svg) center / contain no-repeat;
  width: 27px;
  height: 27px;
  border: none;

  &::before {
    content: '';
    position: absolute;
    left: -5px;
    top: -5px;
    width: calc(100% + 10px);
    height: calc(100% + 10px);
  }

  @media (orientation: portrait) {
    width: clamp(2rem, 0.232rem + 7.857vw, 3.375rem);
    height: clamp(2rem, 0.232rem + 7.857vw, 3.375rem);
    top: 15px;
    right: 15px;
  }
`;

const Content = styled.div`
  position: relative;
`;
